// main modules
export * from './directives';
export * from './services';
// core module
// we explicitly export the module here to prevent this Ionic 2 bug:
// http://stevemichelotti.com/integrate-angular-2-google-maps-into-ionic-2/
export { AgmCoreModule } from './core.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/~/@agm/core/index.js
// module id = ../../../../@agm/core/index.js
// module chunks = 7